import { Grid, Theme, Typography } from "@mui/material";
import React, { FunctionComponent } from "react";
import { makeStyles } from "tss-react/mui";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

interface AlertConfirmDialogProps {
    headline: string;
    textContent: string;
    optionalIconSpacing?: number;
}

const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        padding: 24,
        paddingBottom: 0,
    },

    headline: {
        fontSize: "1.3rem",
        marginBottom: 10,
    },

    icon: {
        fontSize: "64px !important",
        color: "rgba(246,36,71)",
    },
}));

const AlertConfirmDialog: FunctionComponent<AlertConfirmDialogProps> = ({
    headline,
    textContent,
    optionalIconSpacing
}): JSX.Element => {
    const { classes } = useStyles();

    return (
        <Grid container className={classes.container}>
            <Grid item xs={optionalIconSpacing || 4}>
                <ReportProblemIcon className={classes.icon} />
            </Grid>
            <Grid item xs={8}>
                <Typography className={classes.headline}>{headline}</Typography>
                <Typography gutterBottom>{textContent}</Typography>
            </Grid>
        </Grid>
    );
};

export default AlertConfirmDialog;
